import api from 'api';
import { getCreatePublisherDocsOnCallFn } from 'utils/callableFunctions';
import { getBooleanFlag } from 'utils/flags';
import { ResponseOrError, wrapError, wrapSuccess } from 'lib/types/responses';
import { safeAsync } from 'lib/safeWrappers';
import { LaunchDarklyFlags } from 'lib/types/launchDarklyFlags';

export const createPublisherDocsOnCall = async (
  noticeId: string
): Promise<ResponseOrError<void>> => {
  const useCloudRunCreatePublisherDocsOnCall = getBooleanFlag(
    LaunchDarklyFlags.USE_CLOUD_RUN_CREATE_PUBLISHER_DOCS_ON_CALL,
    false
  );

  if (useCloudRunCreatePublisherDocsOnCall) {
    const { error } = await api.safePost<'documents/create-all-publisher-docs'>(
      'documents/create-all-publisher-docs',
      { noticeId }
    );

    if (error) {
      return wrapError(new Error(error));
    }

    return wrapSuccess(undefined);
  }

  const [error] = await safeAsync(
    async () => await getCreatePublisherDocsOnCallFn()({ noticeId })
  )();

  if (error) {
    return wrapError(error);
  }

  return wrapSuccess(undefined);
};
